import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-candidature-form-simplify',
  templateUrl: './candidature-form-simplify.component.html',
  styleUrls: ['./candidature-form-simplify.component.scss']
})
export class CandidatureFormSimplifyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
